import { render, staticRenderFns } from "./DotDropper.vue?vue&type=template&id=634c8d88"
import script from "./DotDropper.vue?vue&type=script&lang=js"
export * from "./DotDropper.vue?vue&type=script&lang=js"
import style0 from "./DotDropper.vue?vue&type=style&index=0&id=634c8d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports